module.exports = __webpack_public_path__ + "img/barUnfilled.f65c0b85.svg";